var localization = {};

export function setLocalization(lang) {
    localization = {...lang};
}

export  function getLabel(label) {
    return localization[label]
}